import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgLightbulbGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    d: "M35.21 21.1c0-6.12-4.98-11.1-11.11-11.1C17.98 10 13 14.98 13 21.1c0 3.71 1.88 7.16 4.94 9.21v3.02c0 1.45 1.18 2.62 2.62 2.62h.48c.22 1.55 1.58 2.75 3.24 2.75 1.66 0 3.01-1.2 3.24-2.75h.44a2.62 2.62 0 0 0 2.62-2.61l.01-3.25c2.87-2.07 4.62-5.41 4.62-8.99ZM24.28 37.46c-.96 0-1.77-.64-1.98-1.5h3.95c-.2.86-1.01 1.5-1.97 1.5Zm5.05-4.12c0 .76-.62 1.37-1.38 1.37h-7.39c-.76 0-1.38-.62-1.38-1.38v-2.79h10.15v2.8Zm-3.08-4.04h-3.94v-4.46c0-1.05.88-1.9 1.97-1.9 1.09 0 1.97.85 1.97 1.9v4.46Zm3.3 0H27.5v-4.46c0-1.74-1.44-3.15-3.22-3.15-1.77 0-3.22 1.41-3.22 3.15v4.46h-2.4c-2.73-1.82-4.41-4.89-4.41-8.19 0-5.43 4.42-9.85 9.85-9.85s9.85 4.42 9.85 9.85c.01 3.29-1.68 6.37-4.4 8.19Z",
    fill: "currentColor"
  }));
}

export { SvgLightbulbGlyph as default };
